import { SliderCore } from './Slider';
export { SliderCore } from './Slider';
export { ThumbBase } from './ThumbBase';
export var Slider = SliderCore;